import React from 'react';
import NoDataFound from '../../../shared/NoDataFound';
import Paginator from '../../../shared/Paginator';
import useToast from './utils/useToast';
import useClipboard from './utils/useClipboard';
import TableSkelton from '../../../shared/TableSkelton';

function getTypeLabel(type) {
  switch (type) {
    case 'image':
      return 'Image (Cube)';
    case 'swiper':
      return 'Swipe Animated';
    case 'upload_file':
      return 'HTML File';
    case 'video':
      return 'Video Ad';
    case 'gif':
      return 'GIF';
    default:
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Unknown';
  }
}

function getDfpUrl(htmlUrl) {
  const campValue = htmlUrl.substring(htmlUrl.lastIndexOf('/') + 1, htmlUrl.lastIndexOf('.html'));
  return `${htmlUrl}?camp=${campValue}`;
}

function CreativesTable({ tableData, tableLoading, totalRows, PAGE_SIZE, currentPage, setCurrentPage, handleEdit, setPreviewDrawer }) {
  const toast = useToast();
  const copyToClipboard = useClipboard();
  return (
    <div className="bg-white min-h-screen">
      <div className=" rounded-2xl overflow-hidden p-2">
        <div >
          <h5 className="text-lg font-semibold m-2">All WebView Creatives</h5>
        </div>
        <div >
          <div className="overflow-x-auto">
            <table className="w-full table table-bordered">
              <thead className="bg-yellow-200">
                <tr>
                  <th className="px-6 py-3 text-left text-gray-700 font-semibold">Name</th>
                  <th className="px-6 py-3 text-left text-gray-700 font-semibold">Type</th>
                  <th className="px-6 py-3 text-left text-gray-700 font-semibold">HTML URL</th>
                  <th className="px-6 py-3 text-left text-gray-700 font-semibold">DFP URL</th>
                  <th className="px-6 py-3 text-left text-gray-700 font-semibold">Created On</th>
                  <th className="px-6 py-3 text-left text-gray-700 font-semibold">Actions</th>
                </tr>
              </thead>
              {tableLoading ? (
                <TableSkelton colspan={6} rowSpan={10} />
              ) : tableData.length === 0 ? (
                <NoDataFound colspan={6} />
              ) : (
                <tbody>
                  {tableData?.map((row) => (
                    <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="px-6 py-4">{row.creative_name}</td>
                      <td className="px-6 py-4">{getTypeLabel(row.type)}</td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <span className="truncate px-2 py-1">{row.html_url}</span>
                          <button
                            className="px-3 py-1 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
                            onClick={() => copyToClipboard(row.html_url, toast)}
                          >
                            Copy
                          </button>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <span className="truncate px-2 py-1">{getDfpUrl(row.html_url)}</span>
                          <button
                            className="px-3 py-1 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
                            onClick={() => copyToClipboard(getDfpUrl(row.html_url), toast)}
                          >
                            Copy
                          </button>
                        </div>
                      </td>
                      <td className="px-6 py-4">{row.created_on ? new Date(row.created_on * 1000).toLocaleString() : '-'}</td>
                      <td className="px-6 py-4">
                        <div className="flex gap-2">
                          <button
                            className="px-3 py-1 rounded-lg border border-blue-500 text-blue-500 hover:bg-blue-50"
                            onClick={() => setPreviewDrawer({ open: true, row })}
                          >
                            View
                          </button>
                          <button
                            className="px-3 py-1 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
                            onClick={() => handleEdit(row)}
                          >
                            Edit
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
          <div className="p-4 flex justify-end">
            {totalRows > PAGE_SIZE && (
              <Paginator
                pageCount={Math.ceil(totalRows / PAGE_SIZE)}
                handlePageClick={(e) => setCurrentPage(e.selected)}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreativesTable;